import {Routes} from '@angular/router'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {AdminComponent} from './admin/home/admin.component'
import {LOGIN_PATH} from './application/app'

export default [
  {
    path: 'main',
    loadComponent: () => import('./main/block/block.component').then(m => m.BlockComponent),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [adminAuthGuard]
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH,
    pathMatch: 'full'
  }
] satisfies Routes